import React from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings'

import { TIMER_MASK_HMMSSS } from 'constants/ui/timers'

import { TimerInput } from 'components/patterns/Inputs'

const OutputValueEditor = ({ value, onOutputValueChange }) => (
  <TimerInput
    label={strings.input_value}
    hint={strings.timer_initial_value_hint}
    name={strings.timer}
    value={value}
    onChange={onOutputValueChange}
    mask={TIMER_MASK_HMMSSS}
    className="form-field"
    data-testid="timer-input"
  />
)

OutputValueEditor.propTypes = {
  value: PropTypes.number,
  onOutputValueChange: PropTypes.func,
}

export default OutputValueEditor
